<div (click)="openImportModal()">
  <ng-container *ngIf="customButton; else defaultBody">
    <ng-container [ngTemplateOutlet]="customButton.templateRef"></ng-container>
  </ng-container>
  <ng-template #defaultBody>
    <button class="btn btn-std-2ry h-input-res d-flex align-items-center
            shadow-none round-input px-3 max-content-width"
        title="{{'COMMON.Upload' | translate}}"
        type="button">
      <svg class="pointer icon-btn-svg"
          stroke="currentColor">
        <use href="assets/images/icons/files/file-earmark-upload.svg#file-earmark-upload"
            height="20"
            width="20">
        </use>
      </svg>
      <span class="ms-2">{{ 'COMMON.Upload' | translate }}</span>
    </button>
  </ng-template>
</div>

<ng-template #importModal
  let-modal>
  <app-modal-confirmation-std4-skin [dismissText]="'COMMON.Cancel' | translate"
      [header]="'BATCH-IMPORT.IMPORT' | translate"
      [submitText]="'COMMON.Confirm' | translate"
      [disabled]="!fileInput"
      (submitted)="send()"
      (dismiss)="modal.dismiss()"
      [bodyNotDesignDownload]="true">
    <ng-template>
      <ng-container [ngTemplateOutlet]="!fileInput ? importFileTemp: checkFileTemp"></ng-container>
    </ng-template>
  </app-modal-confirmation-std4-skin>
</ng-template>

<ng-template #importFileTemp>
  <div class="w-100">
    <label class="fs-base-l0 text-black-neutrals">
      {{ 'BATCH-IMPORT.Import data by using Excel file' | translate }}
    </label>
    <app-drop-file [accept]="'.xlsx, .xls'"
        (fileOutput)="uploadFile($event)">
    </app-drop-file>
  </div>
  <div class="box-example my-u8 p-2">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex">
        <svg height="32"
            width="28">
          <use href="assets/images/pictograms/xlsx.svg#xlsx">
          </use>
        </svg>
        <div class="d-flex flex-column ms-2">
          <div class="fs-base-l2 fw-medium">
            {{ 'BATCH-IMPORT.Example file' | translate }}
          </div>
          <small class="fs-base-l5 text-gray-neutrals">
            {{ 'BATCH-IMPORT.Download the template to format your data correctly.' | translate }}
          </small>
        </div>
      </div>
      <button (click)="example()"
          [ladda]="isDownload"
          type="button"
          class="btn btn-std btn-std-prim btn-h-sm-res fs-l4 px-l4 py-l10 fw-semibold">
        <svg stroke="currentColor"
            stroke-width="2"
            width="16"
            height="16">
          <use href="assets/images/icons/arrows/arrow-down-to-line.svg#arrow-down-to-line"
              width="16"
              height="16">
          </use>
        </svg>
        {{ 'COMMON.Download' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<ng-template #checkFileTemp>
  <label class="fs-base-l0 text-black-neutrals">
    {{ 'BATCH-IMPORT.Import data by using Excel file' | translate }}
  </label>
  <div class="box-input-file d-flex justify-content-between align-items-center px-l8 py-u0">
    <div class="d-flex">
      <svg height="32"
          width="28">
        <use href="assets/images/pictograms/xlsx.svg#xlsx">
        </use>
      </svg>
      <div class="d-flex flex-column ms-2">
        <div class="fs-base-l2 fw-medium">
          {{ fileInput?.name }}
        </div>
        <small class="fs-base-l5 text-gray-neutrals">
          {{ fileSize }}
        </small>
      </div>
    </div>
    <button (click)="clearFile()"
        type="button"
        class="btn btn-std btn-std-2ry btn-h-sm-res fs-l4 px-l4 py-l10 fw-semibold">
      {{ 'BATCH-IMPORT.RE-UPLOAD' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #errorDetailModal
  let-modal>
  <app-modal-confirmation-std4-skin [header]="'BATCH-IMPORT.IMPORT' | translate"
      [submitText]="'BATCH-IMPORT.RE-UPLOAD' | translate"
      [dismissText]="'COMMON.Cancel' | translate"
      [bodyNotDesignDownload]="true"
      (submitted)="openImportModal()"
      (dismiss)="modal.dismiss()">
    <ng-template>
      <div class="">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center gap-3">
            <svg alt="Check Circle"
                height="44"
                width="44"
                color="#FF5777">
              <circle cx="50%"
                  cy="50%"
                  r="50%"
                  fill="#FFEAEE"/>
              <use height="24"
                  width="24"
                  x="10"
                  y="10"
                  stroke="#FF5777"
                  href="assets/images/icons/marks/warning-circle.svg#warning-circle">
              </use>
            </svg>
            <h3 class="fs-base-l0 fw-medium mb-0">{{ 'EXPORT.ERROR-OCCURRED' | translate }}</h3>
          </div>
          <div *ngIf="isArray(errorDetail)"
              class="fs-base-l0 fw-normal text-gray-silver-sand-mid">
            {{ errorDetail.length }} {{ 'BATCH-IMPORT.ITEMS' | translate }}
          </div>
        </div>
        <div class="mt-3">
          <div class="box-error">
            <ng-container *ngIf="!isArray(errorDetail); else errorList">
              {{ errorDetail }}
            </ng-container>
            <ng-template #errorList>
              <ul class="m-0">
                <li *ngFor="let errorItem of errorDetail">
                  {{ errorItem }}
                </li>
              </ul>
            </ng-template>
          </div>
        </div>
      </div>
    </ng-template>
  </app-modal-confirmation-std4-skin>
</ng-template>

<app-loading-progress-bar #progressBarModal
    [initPercent]="5"
    [title]="'BATCH-IMPORT.LOADING'"
    (taskSuccess)="success()"
    (taskFailed)="failed($event)"
></app-loading-progress-bar>
